module.exports = {
  mediaInteCal:function(pcMedia, mobileMedia, digitalMedia, totalMedia){
    var inteAA = this.calcMediaInteProcess(pcMedia, mobileMedia);
    var inteCA = this.calcMediaInteProcess(inteAA, digitalMedia);
    totalMedia.reach1 = inteCA.reach1;
    totalMedia.grps = inteCA.grps;
    totalMedia.af = (totalMedia.grps / totalMedia.reach1).toFixed(2);
  },
  // 외부에서 접근하는 함수
  channelInteCalc:function(media, grps, mediaData){
    // Facebook + GDN
    var inteAA = this.calcInteProcess(media.mediaList['Facebook'], media.mediaList['GDN']);
    this.makeChannelDiagramData(media.mediaList['Facebook'], media.mediaList['GDN'], 'Facebook', 'GDN', inteAA, mediaData.AVennDiagram);
    // KaKao + Naver
    var inteAB = this.calcInteProcess(media.mediaList['Kakao'], media.mediaList['Naver']);
    this.makeChannelDiagramData(media.mediaList['Kakao'], media.mediaList['Naver'], 'Kakao', 'Naver', inteAB, mediaData.BVennDiagram);

    var inteAC = this.calcInteProcess(media.mediaList['컴즈'], media.mediaList['기타(네트워크)']);
    // 기타(포털) + 기타(SNS)
    var inteAD = this.calcInteProcess(media.mediaList['기타(포털)'], media.mediaList['기타(SNS)']);

    var inteAZ = this.calcInteProcess(inteAA, inteAB);
    this.makeChannelDiagramData(inteAA, inteAB, '(FB+GDN)', '(Kakao+Naver)', inteAZ, mediaData.CVennDiagram);

    var inteBA = this.calcInteProcess(inteAA, inteAB);
    var inteBB = this.calcInteProcess(inteAC, inteAD);
    var inteCA = this.calcInteProcess(inteBA, inteBB);
    if( typeof inteCA !== 'undefined'){
      media.resultMedia.reach1 = parseFloat(inteCA.reach1.toFixed(2));
      media.resultMedia.lmt = inteCA.lmt;
      media.resultMedia.grps = parseFloat(grps.toFixed(2));
      media.resultMedia.af = (media.resultMedia.grps / media.resultMedia.reach1).toFixed(2);
    }else{
    }
  },
  makeChannelDiagramData(channelA, channelB, reachALabel, reachBLabel, inteReach, mediaData){

    var a_exist = typeof channelA === 'undefined'?false:true;
    var b_exist = typeof channelB === 'undefined'?false:true;

    if(a_exist && b_exist){
      mediaData.screenCount = 2;
      mediaData.reachALabel = reachALabel;
      mediaData.reachBLabel = reachBLabel;
      mediaData.reachA = channelA.reach1;
      mediaData.reachB = channelB.reach1;
      mediaData.resultMedia.reach1 = inteReach.reach1;
    }else if(a_exist){
      mediaData.screenCount = 1;
      mediaData.label = reachALabel;
      mediaData.reachALabel = reachALabel;
      mediaData.reachA = channelA.reach1;
      mediaData.resultMedia.reach1 = channelA.reach1;
    }else if(b_exist){
      mediaData.screenCount = 1;
      mediaData.label = reachBLabel;
      mediaData.reachBLabel = reachBLabel;
      mediaData.reachB = channelB.reach1;
      mediaData.resultMedia.reach1 = channelB.reach1;
    }else {
      mediaData.screenCount = 0;
    }
  },
  calcInteProcess:function(channelA, channelB){

    result = {
      reach1:0.0,
      lmt:0.0,
      grps:0.0
    }

    // undefined 체크
    var a_exist = typeof channelA === 'undefined'?false:true;
    var b_exist = typeof channelB === 'undefined'?false:true;

    if(a_exist && b_exist){
      var inteReachA = channelA.reach1 + ( channelA.lmt - channelA.reach1 / 100 ) * channelB.reach1;
      var inteReachB = channelB.reach1 + ( channelB.lmt - channelB.reach1 / 100 ) * channelA.reach1;

      // 통합 리치 구하기 ~
      result.reach1 = Math.max(inteReachA, inteReachB);
      // 통합 커버리지 구하기 ~~
      result.lmt = channelA.lmt + channelB.lmt - ( channelA.lmt * channelB.lmt)
      result.grps = parseFloat(channelA.grps) + parseFloat(channelB.grps)
      // 통합 커버리지 판별식
      if(result.lmt > 1){
        result.lmt = 1;
      }

    }else if(a_exist){
      result.reach1 = channelA.reach1;
      result.lmt = channelA.lmt;
      result.grps = channelA.grps;
    }else if(b_exist){
      result.reach1 = channelB.reach1;
      result.lmt = channelB.lmt;
      result.grps = channelB.grps;
    }else {
      result = channelA; // undefined 주입
    }

    return result;
  },

  calcMediaInteProcess:function(channelA, channelB){

    result = {
      reach1:0.0,
      lmt:0.0,
      grps:0.0
    }

    // undefined 체크
    var a_exist = channelA === null?false:true;
    var b_exist = channelB === null?false:true;

    if(a_exist && b_exist){
      var inteReachA = channelA.reach1 + ( channelA.lmt - channelA.reach1 / 100 ) * channelB.reach1;
      var inteReachB = channelB.reach1 + ( channelB.lmt - channelB.reach1 / 100 ) * channelA.reach1;
      // 통합 리치 구하기 ~
      result.reach1 = Math.max(inteReachA, inteReachB);
      // 통합 커버리지 구하기 ~~
      result.lmt = channelA.lmt + channelB.lmt - ( channelA.lmt * channelB.lmt)
      result.grps = parseFloat(channelA.grps) + parseFloat(channelB.grps)
      // 통합 커버리지 판별식
      if(result.lmt > 1){
        result.lmt = 1;
      }

    }else if(a_exist){
      result.reach1 = channelA.reach1;
      result.lmt = channelA.lmt;
      result.grps = channelA.grps;
    }else if(b_exist){
      result.reach1 = channelB.reach1;
      result.lmt = channelB.lmt;
      result.grps = channelB.grps;
    }else {
      result = channelA; // undefined 주입
    }

    return result;
  },

}



// WEBPACK FOOTER //
// ./src/views/common/DAInteLogic.js